// frontend/src/components/grid/GridPage.jsx
//
// The layout of a page's main grid, inside its Tile:
//
//   <Tile …>
//     <GridPage>
//       {banners, filters, <ExpandAllButton/> — rows above the grid}
//       <GridViewport>{gridTheme && <AgGridReact … />}</GridViewport>
//       {anything below the grid}
//     </GridPage>
//   </Tile>
//
// AG Grid's root is `height: 100%`, so it is only as tall as the box it sits
// in resolves to; a box without a definite height leaves the grid an empty
// strip. GridViewport is that box, and GridPage.css owns every rule that sizes
// it: the height the page has left under everything above the grid, and one
// screen-relative height on phones. A page says nothing about height;
// GridPage.test.jsx keeps every page grid inside a GridViewport.

import { createContext, useContext } from 'react';
import './GridPage.css';

// True inside a GridPage; null outside one.
const InsideGridPage = createContext(null);

export function GridPage({ children }) {
  return (
    <InsideGridPage.Provider value={true}>
      <div className="grid-page-container">{children}</div>
    </InsideGridPage.Provider>
  );
}

export function GridViewport({ children }) {
  if (useContext(InsideGridPage) === null) throw new Error('GridViewport must render inside a GridPage, which sizes it.');
  return <div className="grid-page-grid-wrapper">{children}</div>;
}
